import Glide from '@glidejs/glide'
import gsap, {Power0} from "gsap";


const initCarousel = () => {
    if(document.querySelector('.glide')){
        const allGlides = document.querySelectorAll('.glide');
        allGlides.forEach(slider => {
           let glide = new Glide(slider, {
                type: 'slider',
                startAt: 0,
                perView: 3,
                gap: 24,
                rewind: false,
                breakpoints:{
                    1281:{
                        perView: 2.5
                    },
                /*    1025:{
                        perView: 2.5
                    },*/
                    769:{
                        perView: 2.15
                    },
                    569:{
                        perView: 1.15
                    }
                }
            }).mount()
            glide.on('run.before', (ev) => {
                const allCards = document.querySelectorAll('.kirinus-carousel-card__dark');
                if(allCards.length > 0){
                    allCards.forEach(card => {
                        if (card.classList.contains('kirinus-carousel-card__team')) {
                            let tl = gsap.timeline({})
                            let cardText = card.querySelector('.card-text');
                            let cardBody = card.querySelector('.card-body');
                            let toggle = card.querySelector('.kirinus-carousel-card--toggle-icon');
                            let cardShade = card.querySelector('.kirinus-carousel-card__team-shade');
                                tl.timeScale(3)
                                tl.to(cardText, {display: 'none', duration: 0.1}, 1);
                                tl.to(cardBody, {justifyContent: 'flex-end', duration: 1}, 1);



                                tl.fromTo(cardText, {opacity: 1}, {opacity: 0, duration: 1}, 1);


                                tl.fromTo(cardShade, {height: '100%'}, {height: '0%', duration: 1}, 1)
                                tl.fromTo(toggle, {rotation: 45, filter: 'brightness(0) invert(1)'}, {
                                    rotation: 0,
                                    filter: '',
                                    ease: Power0.easeInOut,
                                    duration: 0.5
                                }, 1)


                        }
                        card.classList.remove('kirinus-carousel-card__dark');
                    })
                }
            })

            const allSlides = Array.from(slider.querySelectorAll('.glide__slide'));
            slider.addEventListener('click', ev =>{
                if(!ev.target.closest('.glide__slide')) return;
                let clicked = ev.target.closest('.glide__slide');
                let theIndex = allSlides.indexOf(clicked);
                if(theIndex > -1 && theIndex !== glide.index){
                    let targetString = '='+theIndex;
                    glide.go(targetString);
                }
            })
        })

    }


}
export default initCarousel;